/* =================== CARROSSEL PRUDUTOS =================== */
$(function () {
  $(".carrosel-produtos").slick({
    slidesToShow: 5,
    slidesToScroll: 5,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
          dots: $(".carrosel-produtos .bloco-produto").length > 2,
        },
      },
    ],
  });
});
